import { Component } from '@angular/core';
import { SplUiTagline } from '../../components';

@Component({
  selector: 'spl-ui-coming-soon-feature',
  imports: [SplUiTagline],
  templateUrl: './coming-soon.feature.html',
  styleUrl: './coming-soon.feature.scss',
})
export class SplUiComingSoonFeature {}
